import { Component, Inject, OnInit, Optional, OnDestroy } from '@angular/core';
import { ErrorService } from '../../core/services/error.service';
import { ActivatedRoute } from '@angular/router';
import { DocumentType } from '../../core/enum/document.enum';
import { DocumentService } from '../../core/services/api/document.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Meta } from '@angular/platform-browser';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-document',
    templateUrl: './document.component.html',
})
export class DocumentComponent implements OnInit, OnDestroy {
    protected isLoading = false;
    protected isPopup = false;
    protected documentType!: string;
    protected documentContent!: string;
    protected title: string = '-';

    constructor(
        @Inject(MAT_DIALOG_DATA) @Optional() public data: { type?: string } | null,
        private errorService: ErrorService,
        private documentService: DocumentService,
        private activatedRoute: ActivatedRoute,
        private meta: Meta,
    ) {}

    ngOnInit(): void {
        if (this.data?.type) {
            this.documentType = this.data.type;
            this.isPopup = true;
        } else {
            this.activatedRoute.paramMap.subscribe(() => {
                this.documentType = this.activatedRoute.snapshot.paramMap.get('type')!;
            });
        }
        
        this.getDocument();
        this.setPageTitle();
        this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' })
    }

    ngOnDestroy(): void {
        console.log("On Destroy the document component")
        this.meta.updateTag({ name: 'robots', content: 'index, follow'})
    }


    private getDocument(): void {
        this.isLoading = true;

        // TODO  : Not a good practice to use tertianary operator for this case
        const observable =
            this.documentType === DocumentType.TermsAndCondition
                ? this.documentService.getTermsAndCondition()
                : this.documentType === DocumentType.PrivacyPolicy ? this.documentService.getPrivacyPolicy() : this.documentService.getRefundPolicy();

        observable.pipe(finalize(() => (this.isLoading = false))).subscribe({
            next: (resp) => {
                this.documentContent = resp.result;
            },
            error: (error) => {
                this.errorService.showError(error);
            },
        });
    }

    private setPageTitle(): void {
        if (this.documentType === DocumentType.TermsAndCondition) {
            this.title = 'text.termsAndConditions';
        } else if (this.documentType === DocumentType.PrivacyPolicy) {
            this.title = 'text.privacyPolicy';
        } else if (this.documentType === DocumentType.RefundPolicy) {
            this.title = 'text.refundPolicy';
        }
    }
}
